import { Component, OnInit, ViewChild, AfterViewInit, Input, ElementRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { EmployeeInsurance } from '../../shared/models/EmployeeInsurance.model';
import { UserService } from '../../shared/service/user.service';
import { EmployeeService } from '../../shared/service/employee.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { EmpInsurance } from '../../shared/models/EmpInsurance';
import { isNullOrUndefined } from 'util';
import { InsuranceInfo } from '../../shared/models/insuranceinfo';
import { EmployeeInsuranceInfo } from '../../shared/models/employeeinsuranceinfo';
import * as xlsx from 'xlsx';
const getFileName = (name: string) => {
  let timeSpan = new Date().toISOString();
  let sheetName = name || "ExportResult";
  let fileName = `${sheetName}-${timeSpan}`;
  return {
    sheetName,
    fileName
  };
};
@Component({
  selector: 'app-employee-insurance-list',
  templateUrl: './employee-insurance-list.html'
})

export class EmployeeInsuranceListComponent implements OnInit {
  empList: EmployeeInsurance[];
  employeeInsuranceInfos: EmployeeInsuranceInfo[]
  error: string;
  result: any;
  premiumYearList: any;
  premiumYearId: number;
  insuranceArray: EmpInsurance;
  dataSourceFTE: MatTableDataSource<EmployeeInsurance>;
  deleteEnable: boolean = false;
  permission: any;
  @Input() LoginEmpCode: any;
  constructor(private userService: UserService, private empSvc: EmployeeService, public dialog: MatDialog, private toastr: ToastrService) {
    this.empList = [];
    this.dataSourceFTE = new MatTableDataSource;

  }
  displayedColumns: string[] = ['EmpCode', 'Name', 'LocationName', 'EmpEmailId', 'SumAssured','SumAssuredParents','PremiumYear', 'Status', 'Delete'];
  @ViewChild(MatPaginator, { static: false }) paginatorFTE: MatPaginator;
  @ViewChild(MatSort, { static: false }) sortFTE: MatSort;
  @ViewChild('input', { static: false }) input: ElementRef;
  @ViewChild('epltable', { static: false }) epltable: ElementRef;
  check: boolean = false;
  ngOnInit() {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.getPremiumYearList();

    this.permission = this.userService.userInfo.permissions.find(i => i.Menu === 'Insurance' && i.Name ==='Insurance-HR');
    if (this.permission.HasFullAccess || this.permission.DeletingPermission) {
      this.deleteEnable = true
    }
  }
  getEmployeeDetails() {
    this.empList = [];
    this.dataSourceFTE = new MatTableDataSource;
    this.empSvc.GetEmployeesInsuranceDetails(this.premiumYearId).subscribe(
      (data: InsuranceInfo) => {
        this.empList = data.employeeInsurances;
        this.employeeInsuranceInfos= data.employeeInsuranceInfos
        this.dataSourceFTE.data = this.empList;
        this.dataSourceFTE.paginator = this.paginatorFTE;
        this.dataSourceFTE.sort = this.sortFTE;
      });

  }
  getPremiumYearList() {
    this.empSvc.GetInsurancePermium().subscribe((data: any) => {
      if (isNullOrUndefined(this.premiumYearId) || this.premiumYearId == 0) {
        this.premiumYearId = data.find(x => x.IsActive == true).Id;
      }
      this.premiumYearList = data;
      this.getEmployeeDetails();
    });
  }
  applyFilter(filterValue: string) {
    this.dataSourceFTE.filter = filterValue.trim().toLowerCase();
  }
  deleteEmployee(val) {
    this.insuranceArray = new EmpInsurance();
    this.insuranceArray.EmpCode = val.EmpCode;
    this.insuranceArray.ModifiedBy = this.LoginEmpCode;
    this.insuranceArray.PremiumYearId = this.premiumYearId;
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.empSvc.CancelEmployeeInsurance(this.insuranceArray).subscribe(data => {
          this.toastr.success("Deleted successfully");
          this.getEmployeeDetails();
        },
          error => this.error = error
        );
      }
    }, error => { this.result = error; });

  }

  onPremiumYearChange(val) {
    this.premiumYearId = val.value;
    this.getEmployeeDetails();
  }

  exportToExcel() {


    let { sheetName, fileName } = getFileName(name);

    var wb = xlsx.utils.book_new();
    var ws = xlsx.utils.json_to_sheet(this.employeeInsuranceInfos);
    xlsx.utils.book_append_sheet(wb, ws, sheetName);
    xlsx.writeFile(wb, `${fileName}.xlsx`);
    //TableUtil.exportArrayToExcel(onlyNameAndSymbolArr, "ExampleArray");
  }
}

